import { render, staticRenderFns } from "./DocumentsGroup.vue?vue&type=template&id=1034cd31"
import script from "./DocumentsGroup.vue?vue&type=script&lang=ts"
export * from "./DocumentsGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports